<template>
  <div>
    <div class="right author-right" v-if="booklist && booklist.length <= 0">
        <div class="datanull">
          <img class="" src="@/assets/author/no-data.png"/>
          <p>{{$lang('authorCenter.stories.noStory')}}</p>
        </div>
    </div>
    <div class="right right-no author-right" v-else>
      <ul class="collectlist mywrite clearfix">
        <li class="flexible f-csp" v-for="book in booklist" :key="book.id" :class="{ small: small }" @click.stop="goBookSet(book, 'list')">
          <div class="book-cover mt24 ml24">
            <img :src="`${book.iiconUrlMedium}`"/>
          </div>
          <div class="book-info ml24 flex mt24 text-fff font-MT">
            <div class="name text-hidden" :title="isSign ? book.name : book.iname">{{isSign ? book.name : book.iname }}</div>
            <div class="book-deatil f14">
              <span><i>{{book.chapterCount}}</i>{{$lang('authorCenter.stories.chapters')}}</span>
              <span><i>{{book.words}}</i>{{$lang('authorCenter.stories.words')}}</span>
              <span><i>{{book.inspectDesc}}</i>{{$lang('authorCenter.stories.status')}}</span>
            </div>
          </div>
          <div class="book-btn">
            <a
                    href="javaScript:"
                    class="new-dis-btn flexible aItem-center f-nto"
                    v-if="book.finished"
            >
              <img src="@/assets/author/list-dis-chapter.png"/>{{$lang('authorCenter.stories.newChapters')}}</a
            >
            <a
                    v-else
                    href="javaScript:"
                    class="new-btn flexible aItem-center"
                    @click.stop="goBookSet(book, 'add')"
            >
              <img src="@/assets/author/list-new-icon.png"/>{{$lang('authorCenter.stories.newChapters')}}</a
            >
            <a
                    href="javaScript:"
                    class="list-btn flexible aItem-center"
                    @click.stop="goBookSet(book, 'list')"
            ><img src="@/assets/author/list-icon.png"/>{{$lang('authorCenter.stories.chapterList')}}</a
            >
            <a
                    href="javaScript:"
                    class="Edit-btn flexible aItem-center"
                    @click.stop="goBookSet(book, 'edit')"
            >
              <img src="@/assets/author/list-edit-icon.png"/>{{$lang('authorCenter.stories.editStory')}}</a
            >
          </div>
        </li>
      </ul>
    </div>
    <addEmail ref="addEmail" v-if="ispopshow" :book="book" @closeEmail="closeEmail"></addEmail>
  </div>
</template>

<script>
import baseURL from "@/api/env";
import addEmail from "./addEmail";
import {getNormalInfo} from '@/api/author'
export default {
  props: {
    booklist: {
      type: Array,
      default: () => {
        return null;
      }
    },
    isSign: Boolean,
    small: Boolean
  },
  data () {
    return{
      imgURL: baseURL.IMG,
      ispopshow: false,
      book: {}
    }
  },
  components: {addEmail},
  methods: {
    goBookSet(item, flag) {
      if (flag == 'add') {
        if (item.chapterCount == 3) {
          this.book = item
          this.getNormalInfoFun(item)
        } else {
          this.$router.push(`/authorManage/newChapter/${item.id}/0/${item.allowPrice}`);
        }
      } else if (flag == 'list') {
        this.$router.push("/authorManage/chapterList/" + item.id);
      } else if (flag == 'edit') {
        this.$router.push('/Create/'+item.id)
      }
    },
    async getNormalInfoFun (item) {
      let res = await getNormalInfo()
      // console.log(res)
      if (res.success) {
        let info = res.data.authorDto
        if (info && info.email) {
          this.$router.push(`/authorManage/newChapter/${item.id}/0/${item.allowPrice}`);
        } else {
          this.closeEmail(true)
        }
      }
    },
    closeEmail (data) {
      this.ispopshow = data
      this.$emit('changePop', data)
    },
  }
};
</script>

<style lang="scss" scoped>
  @import "@/styles/author.scss";
  .collectlist{
    li{
      display: inline-block;
      width: 100%;
      height: 272px;
      background: #272736;
      box-shadow: 0px 2px 20px 0px rgba(0,0,0,0.1);
      border-radius: 16px;
      margin-bottom: 24px;
      .book-cover{
        width: 160px;
        height: 210px;
        img{
          width: 160px;
          height: 210px;
        }
      }
      .book-info{
        .name{
          font-size: 28px;
          margin-top: 26px;
          font-weight: bold;
          word-break: break-all;
          line-clamp: 2;
          -webkit-line-clamp: 2;
        }
        .book-deatil{
          margin-top: 48px;
          i{
            font-size: 24px;
            margin-right: 5px;
          }
          span{
            margin-right: 20px;
          }
        }
      }
      .book-btn{
        margin-top: 46px;
        a{
          width: 180px;
          height: 40px;
          border-radius: 4px;
          line-height: 40px;
          display: block;
          margin-right: 24px;
          background: #3B3B51;
          color:#fff;
          margin-bottom: 30px;
          img{
            margin-left: 13px;
            margin-right: 10px;
          }
          &:hover{
            background: rgba(132,88,248,0.34);
          }
        }
      }
    }
  }
</style>
